const styles = () => ({
  actionButtons: {
    '& button': {
      marginLeft: '16px',
      height: '40px'
    }
  },
  buttonsRoot: {
    padding: 0
  },
  container: {
    flex: '1 auto',
    '& span': {
      float: 'left'
    }
  },
  estimatedArrival: {
    marginLeft: '16px'
  },
  listIcon: {
    float: 'left'
  },
  mapIcon: {
    float: 'right',
    textAlign: 'right'
  },
  rightContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  statusBar: {
    minHeight: '48px',
    minWidth: '220px',
    backgroundColor: '#FEE5B1',
    border: '1px solid #FEB00B',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row wrap',
    fontFamily: 'Roboto',
    fontSize: '16px'
  },
  statusLabel: {
    fontWeight: 'bold'
  },
  statusDropdown: {
    marginRight: '0'
  },
  shipmentId: {
    fontFamily: 'Rubik',
    fontSize: '24px',
    fontWeight: '500'
  },
  shipmentIdRow: {
    marginBottom: '27px',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    minHeight: '29px',
    minWidth: '220px'
  },
  verticalLine: {
    width: '1px',
    backgroundColor: '#E0E4E6',
    height: '17px',
    float: 'left',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  viewButtons: {
    width: '80px',
    height: '24px',
    '& .icon': {
      display: 'inline',
      width: '50%',
      height: '100%'
    },
    marginLeft: '30px'
  }
});

export default styles;
